
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import { Table } from '@/interfaces/models/Table';
import { PromoCode } from '@/interfaces/models/PromoCode';
import { Tag } from '@/interfaces/models/Tag';
import headers from './headers';

const promo = namespace('promo');
const table = namespace('table');

@Component({
  components: { VTable },
})
export default class TableTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Table[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public tags!: Tag[];

  @promo.Action('show') public getPromoById!: any;
  @table.Action('show') public getTableById: any;
  @promo.State('active') public activePromo!: PromoCode;
  @table.State('active') public activeTable: any;

  public $refs!: {
    table: InstanceType<typeof VTable> & { selected: any[] };
  };

  public headers: ColumnHeader[] = headers;
  public show: boolean = false;

  public selectedTableIdForCounters: string | null = null;
  public selectedSanifairPromotionCounters: any[] | null = null;

  public edit(item: Table) {
    this.$router.push({ name: 'table.edit', params: { id: item._id }, query: { ...this.$route.query } });
  }

  public getSelected(): Table[] {
    return this.$refs.table.selected;
  }

  public async viewCounters(item: Table) {
    if (!item.sanifairPromotionCounters || typeof item.sanifairPromotionCounters !== 'object') {
      return;
    }

    const entries = Object.entries(item.sanifairPromotionCounters);

    const countersArray: any[] = await Promise.all(
      entries.map(async ([key, value]) => {
        await this.getPromoById({ id: key });
        const promoCode = this.activePromo || null;

        return { number: item.number, promoCode: promoCode?.name || key, value };
      }),
    );

    this.selectedTableIdForCounters = item._id;
    this.selectedSanifairPromotionCounters = countersArray;

    this.setShowModal(true);
  }

  public async reloadCounters() {
    this.$startLoading('reload_counters');
    await this.getTableById({ id: this.selectedTableIdForCounters });
    this.$stopLoading('reload_counters');

    const item = this.activeTable;

    if (!item?.sanifairPromotionCounters) {
      return;
    }

    this.viewCounters(item);
  }

  public setShowModal(value: boolean) {
    this.show = value;

    if (!value) {
      this.selectedTableIdForCounters = null;
      this.selectedSanifairPromotionCounters = null;
    }
  }

  public prettifyTags(tagIds: string[]): string {
    return tagIds
      .map((tagId: string) => {
        const tagName = this.tags.find((tag) => tag._id === tagId)?.name;
        return tagName ? this.$options.filters!.localized(tagName) : tagId;
      })
      .join(', ');
  }
}
